import { http, HttpResponse } from "msw"
import type { ApiLabPurchases } from "../../laboratoryPurchases"
import { labPerfPurchasesMock } from "./labPurchases.mock"

const API_DOMAIN = import.meta.env.VITE_API_DOMAIN

export const financialDataLabPurchases = [
  http.get(`${API_DOMAIN}/api/financial-data/laboratory/purchases`, () =>
    HttpResponse.json<ApiLabPurchases>(labPerfPurchasesMock()),
  ),
  http.get(`${API_DOMAIN}/api/financial-data/laboratories/:labId/purchases`, () =>
    HttpResponse.json<ApiLabPurchases>(labPerfPurchasesMock()),
  ),
]
